import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function ClosingSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section background="white" className="text-center" data-id="element-1">
      <div className="max-w-xl mx-auto" data-id="element-2">
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4" data-id="element-3">
          No estás exagerando.
        </h2>

        <div className="text-[#2d3748] mb-6" data-id="element-4">
          <p className="mb-3 text-sm md:text-base" data-id="element-5">
            Tampoco estás loco(a). Si la pantalla ya se volvió motivo de pelea
            diaria, no es "una etapa".
          </p>
          <p className="mb-4 text-sm md:text-base" data-id="element-6">
            Es un hábito que está tomando el lugar de cosas que sí importan:
            sueño, convivencia, juego, enfoque, carácter.
          </p>
          <p className="text-lg font-medium text-[#1e3a5f]" data-id="element-7">
            La buena noticia: cuando tú vuelves a liderar, tu hijo descansa.
          </p>
        </div>

        <Button onClick={scrollToPricing} size="md" variant="primary" data-id="element-8">
          Haz clic y empieza hoy
        </Button>
      </div>
    </Section>;
}